import { Chip } from '@mui/material';
import { getNotificationIndex } from '../utils';
import type { RuleNotifications } from 'types/notification.types';

interface Props {
  assetNotifications: RuleNotifications[];
}

export function AssetCardNotificationChip({ assetNotifications }: Props) {
  const notificationIndex = getNotificationIndex(assetNotifications);
  return (
    <div>
      <Chip
        label={notificationIndex.message}
        variant="outlined"
        sx={{
          color: '#ffffff',
          backgroundColor: notificationIndex.color,
          borderRadius: '8px',
          border: 'none',
          fontSize: '0.7rem',
        }}
      />
    </div>
  );
}

export default AssetCardNotificationChip;
